import { render } from "./DSecondPart.vue?vue&type=template&id=7569b895&scoped=true"
import script from "./DSecondPart.vue?vue&type=script&lang=js"
export * from "./DSecondPart.vue?vue&type=script&lang=js"

import "./DSecondPart.vue?vue&type=style&index=0&id=7569b895&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7569b895"]])

export default __exports__